module.exports = __webpack_public_path__ + "static/media/car_right.641739e2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/static/audio/car_right.mp3
// module id = 636
// module chunks = 0